import React from 'react';
import { connect } from 'react-redux';
//Actions
import { logGet } from '../../actions/log';
// Material UI
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import SelectClan from '../SelectClan';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

function SelectLog({ clan, logGet, setClan, setView, view }) {
  const classes = useStyles();
  const handleClanSelect = (selectedClan) => {
    logGet(view, selectedClan);
    setClan(selectedClan);
  };
  return (
    <div>
      <FormControl className={classes.formControl}>
        <InputLabel>Ver Registros</InputLabel>
        <Select value={view} onChange={(e) => setView(e.target.value)}>
          <MenuItem value={'app'}>App</MenuItem>
          <MenuItem value={'guard'}>Guardia</MenuItem>
          <MenuItem value={'intercom'}>Intercom</MenuItem>
          <MenuItem value={'phonebot'}>Llamada</MenuItem>
          <MenuItem value={'pass'}>Pases</MenuItem>
          <MenuItem value={'tag'}>Tarjetas</MenuItem>
          {/* <MenuItem value={'monitor'}>Monitor</MenuItem> */}
        </Select>
      </FormControl>
      <SelectClan clan={clan} setClan={handleClanSelect} />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  logGet: (method, clan) => dispatch(logGet(method, clan)),
});

export default connect(null, mapDispatchToProps)(SelectLog);
